import React, { useEffect, useState } from 'react';
import EmployeeFeedbackFlagTypeDropdown, {
  FEEDBACK_FLAG_TYPES_ALIAS,
} from 'domain/people/employee/Timeline/shared/input/EmployeeFeedbackFlagTypeDropdown';
import {
  useFilterContext,
  EqCondition,
  IN_CONDITION_TYPE,
  FilterInputDecorator,
  DropDownFilterProps,
} from 'framework/list';
import { FilterCondition } from 'framework/types';
import { FEEDBACK_FLAGS } from 'domain/people/employee/Timeline/feedback/shared/input/FlagAsInappropriateRadioButtonGroup';
import { FEEDBACK_INAPPROPRIATE_DEFAULT_FLAG } from 'domain/people/employee/Timeline/feedback/shared/button/FeedbackFlagAsInappropriateButton';

const EmployeeTimelineFeedbackFlagTypeFilter = ({ source, ...props }: Omit<DropDownFilterProps, 'children'>) => {
  const [dropdownValue, setDropdownValue] = useState<any>(null);
  const { filterBy, getValue } = useFilterContext();
  const flags = Object.keys(FEEDBACK_FLAGS);

  const handleChange = (data: Dictionary<any>) => {
    const value = data[source][FilterCondition.EQ];

    const resultInValue = value === FEEDBACK_FLAG_TYPES_ALIAS.CORRECT ? [FEEDBACK_INAPPROPRIATE_DEFAULT_FLAG] : flags;

    filterBy({
      [source]: {
        [IN_CONDITION_TYPE]: resultInValue,
      },
    });
    setDropdownValue(value);
  };

  useEffect(() => {
    const value = getValue(source, IN_CONDITION_TYPE);
    let result;

    if (value) {
      if (value[0] === FEEDBACK_INAPPROPRIATE_DEFAULT_FLAG) {
        result = FEEDBACK_FLAG_TYPES_ALIAS.CORRECT;
      } else {
        result = FEEDBACK_FLAG_TYPES_ALIAS.INAPPROPRIATE;
      }
    }

    setDropdownValue(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResetCallback = () => {
    setDropdownValue(null);
  };

  return (
    <EqCondition {...props} source={source} onChangeCallback={handleChange} value={dropdownValue}>
      <FilterInputDecorator cleanableFilters={[source]} onResetCallback={onResetCallback}>
        <EmployeeFeedbackFlagTypeDropdown source={source} />
      </FilterInputDecorator>
    </EqCondition>
  );
};

export default EmployeeTimelineFeedbackFlagTypeFilter;
